var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGradient({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    viewBox: "0 0 24 24",
    style: {
      position: "fixed"
    },
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_svg__gradient",
    gradientTransform: "rotate(45)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff8540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e72828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_svg__highlight5",
    gradientTransform: "rotate(45)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#c66548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ba3c3f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_svg__highlight7",
    gradientTransform: "rotate(45)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffaa79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f43b3b"
  })))));
}

export default SvgGradient;